// extracted by mini-css-extract-plugin
module.exports = {"explanation":"LoversHaters_explanation__2CIid"};